import Vue from "vue"
import config from '../config'

export default {
    searchContacts(value, params = {}){
        return Vue.http.get(config.apiBaseUrl + '/search/contact?query=' + value, { params }).then((response) => response.json());
    },

    searchAddresses(value) {
        return Vue.http.get(config.apiBaseUrl + '/search/address?query=' + value).then((response) => response.json());
    }
}
